var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-grid-vue',{ref:_vm.name,class:_vm.classes,style:({width: _vm.width, margin: '17px'}),attrs:{"name":_vm.name,"rowHeight":_vm.rowHeight,"column-defs":_vm.columnDefs,"row-data":_vm.rows,"grid-options":_vm.gridOptions,"dom-layout":_vm.domLayout,"frameworkComponents":_vm.frameworkComponents}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cf0dabe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SigmaClientNew/TransactionsConfList.vue
// module id = cCqB
// module chunks = 1